import { createContext, useContext, useState, useMemo, useCallback } from "react";
import { translations, defaultLocale } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => {
    try {
      return localStorage.getItem("lab2513_lang") || defaultLocale;
    } catch {
      return defaultLocale;
    }
  });

  const setLang = useCallback((next) => {
    setLocale(next);
    try {
      localStorage.setItem("lab2513_lang", next);
    } catch {
      /* ignore */
    }
  }, []);

  const value = useMemo(
    () => ({
      locale,
      t: translations[locale],
      setLocale: setLang,
      toggle: () => setLang(locale === "pt" ? "en" : "pt"),
    }),
    [locale, setLang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
